import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Breadcrumbs, Typography, Tooltip, Fab } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
import Layout from '@components/Layout';
import MailingListTable from '@components/mailinglist/MailingListTable';
import MailingListCreationDialog from '@components/mailinglist/MailingListCreationDialog';

function MailingListListPage() {
    const { t } = useTranslation();
    const [modalCreateOpen, setModalCreateOpen] = useState(false);
    const [reloadTable, setReloadTable] = useState(false);
    const [reloadDialog, setReloadDialog] = useState(false);
    
    const openCreateDialog = () => {
        setModalCreateOpen(true);
        setReloadDialog(prev => !prev); // Inverser l'état pour déclencher le rechargement
    };

    const onImportDone = () => {
        setReloadTable(prev => !prev); // Inverser l'état pour déclencher le rechargement
    };

    return (
        <Layout withFloatingButton={true}>
            <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 2 }}>
                <Typography>{t('Mailing list management')}</Typography>
            </Breadcrumbs>
            <MailingListTable reloadTable={reloadTable} />
            <Tooltip title={t('Create mailing list')} placement="top" arrow>
                <Fab color="primary" aria-label={t('Create mailing list')}
                    className="main-fab" sx={{ boxShadow: 6 }}
                    onClick={openCreateDialog}>
                    <AddIcon />
                </Fab>
            </Tooltip>

            <MailingListCreationDialog modalCreateOpen={modalCreateOpen} reloadDialog={reloadDialog}
                setModalCreateOpen={setModalCreateOpen} onImportDone={onImportDone} />

        </Layout>
    );
}

export default MailingListListPage;
